import React, { useState, useEffect } from 'react'
import MicroModal from 'micromodal'
import Modal from '../components/common/modal/Modal'
import Button from '../components/common/button/Button'
import Icons from '../components/common/icons/Icons'

async function removeLicenseFromPreset(licenseID, orgID, presetID) {
    const url = restUrl + '/wp-json/membersync/licensing/v1/org/' + orgID + '/delete/preset/' + presetID + '/datas'
    const nonce = restNonce

    await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            'datas': [
                { 'value': licenseID }
            ],
            'remove_type': 'license'
        }),
        headers:{
            'X-WP-Nonce': nonce,
            'Content-type': 'application/json'
        }
    }).then(resp => {
        return resp.json()
    })
    .then((json) => {
    })
}

const CreateLicensePreset = (props) => {

    MicroModal.init()

    const [errorMessage, setErrorMessage] = useState('')
    const [selectedLicenses, setSelectedLicenses] = useState( props.selectedLicenses ?? [] )
    const [processingPreset, setProcessingPreset] = useState(false)

    const modalID = props.type === "edit" ? "msync-org-edit-license-preset-" + props.presetID : "msync-org-create-license-preset"

    async function addLicensePreset(name, licenses, type, orgID){
        const url = restUrl + '/wp-json/membersync/licensing/v1/org/' + orgID + '/create/preset'
        const nonce = restNonce
    
        const res = await fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                'name': name,
                'datas': licenses,
                'preset_type': 'license'
            }),
            headers:{
                'X-WP-Nonce': nonce,
                'Content-type': 'application/json'
            }
        })

        setProcessingPreset(false)
        props.afterEdit()
        MicroModal.close(modalID)
    }

    async function editLicensePreset(name, licenses, presetID, type, orgID){

        const url = restUrl + '/wp-json/membersync/licensing/v1/org/' + orgID + '/edit/preset'
        const nonce = restNonce
    
        const res = await fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                'name': name,
                'datas': licenses,
                'type': 'license',
                'preset_id': presetID
            }),
            headers:{
                'X-WP-Nonce': nonce,
                'Content-type': 'application/json'
            }
        })

        setProcessingPreset(false)
        props.afterEdit()
        MicroModal.close(modalID)
    }

    useEffect(() => {
        if ( processingPreset ) {
            const presetName = tangibleFields.store.getValue('membersync-org-license-preset-name')
            const licenses = tangibleFields.store.getValue('membersync-org-license-preset-licenses')
            if ( props.type === 'edit' ) {
                editLicensePreset( presetName, licenses, props.presetID, props.type, props.orgID )
            } else [
                addLicensePreset( presetName, licenses, props.type, props.orgID )
            ]
        }
    }, [processingPreset])

    return (
        <>
            <Modal 
                modalId={modalID} 
                buttonTitle='' 
                modalHeading={props.type === 'edit' ? 'Manage' : 'Create'}
                modalClassNames={'msync-members-custom-modal msync-members-custom-modal-border'}
            >
                <main className="modal__content">
                    <span>{errorMessage}</span>
                    <div className="membersync-org-modal-row">
                        {
                            tangibleFields.render({
                                type: 'text',
                                label: 'Preset Name',
                                name: 'membersync-org-license-preset-name',
                                value: props.presetTitle ?? '',
                                wrapper: {
                                    class: 'membersync-org-license-preset-name'
                                }
                            })
                        }
                    </div>
                    <div className="membersync-org-modal-row">
                        <div class="membersync-org-license-preset-modal-title">
                            <div>
                                Member Name
                            </div>
                            <div>
                                Actions
                            </div>
                        </div>
                        {
                            selectedLicenses.selected && (selectedLicenses.selected).map((license) => {
                                return (
                                    <div class="membersync-org-license-preset-modal-content">
                                        <div>
                                            { license.title }
                                        </div>
                                        <div>
                                            <Button 
                                                className="msync-modal__close" 
                                                aria-label="Remove license" 
                                                onClick={()=> removeLicenseFromPreset( license.id, props.orgID, props.presetID ) }
                                            >
                                                <Icons type='close' color='red' />
                                                <span className="msync-visually-hidden">Remove license</span>
                                            </Button>
                                            {/* {
                                                tangibleFields.render({
                                                    type: 'button',
                                                    content: 'Remove',
                                                    onClick: () => {
                                                        
                                                    },
                                                    context: 'wp'
                                                }, 'element')
                                            } */}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="membersync-org-modal-row">
                    {
                            tangibleFields.render({
                                type: 'combo-box',
                                label: 'Licenses',
                                name: 'membersync-org-license-preset-licenses',
                                isAsync: true,
                                multiple: true,
                                ajaxAction: 'get_licenses',
                                asyncArgs: {
                                    type: 'license',
                                    org: props.orgID
                                }
                            })
                        }
                    </div>
                    <footer className="msync-modal__footer">
                        <Button 
                            className="msync-button--is-style-outline msync-button--is-theme-destructive" 
                            onClick={() => {
                                MicroModal.close(modalID)
                            }}
                            isDisabled={ processingPreset } 
                        >
                            Cancel
                        </Button>
                        <Button 
                            type="button" 
                            onClick={() => {
                                setProcessingPreset(true)
                            }}
                            isDisabled={ processingPreset }
                        >
                            Save
                        </Button>
                    </footer>
                </main>
            </Modal>
        </>
    );
};

export default CreateLicensePreset;